<template>
    <client-page class="app--main">
        <main-visual />
        <main-efficient lang="en" />
        <main-practice-areas lang="en" />
        <main-attorneys lang="en" />
        <main-location lang="en" />

        <popup-layer />
    </client-page>
</template>

<script>
import Swiper from "swiper/bundle";
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import MainVisual from "@/components/client/main/main-visual.vue";
import PopupLayer from "@/components/client/popup/popup-layer.vue";
import MainLinkCard from "@/components/client/main/main-link-card.vue";
import LawyerCards from "@/components/dumb/lawyer-cards.vue";
import MainEfficient from "@/components/client/main/main-efficient.vue";
import MainPracticeAreas from "@/components/client/main/main-practice-areas.vue";
import MainAttorneys from "@/components/client/main/main-attorneys.vue";
import MainLocation from "@/components/client/main/main-location.vue";

export default {
    components: {
        ClientPage,
        MainVisual,
        PopupLayer,
        MainLinkCard,
        LawyerCards,
        MainEfficient,
        MainPracticeAreas,
        MainAttorneys,
        MainLocation,
    },
    props: {},
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            this.$nextTick(() => {
                setTimeout(function () {
                    this.swiper = new Swiper(".visual .swiper-container", {
                        effect: "fade",
                        allowTouchMove: true,
                        centeredSlides: true,
                        spaceBetween: 0,
                        autoplay: {
                            delay: 6000,
                            disableOnInteraction: false,
                        },
                        speed: 500,
                        loop: true,
                        pagination: {
                            el: ".visual-pagination",
                            clickable: true,
                        },
                    });
                }, 0);
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.visual {
    position: relative;
    width: 100%;
    height: 100vh;
    .swiper-container,
    .swiper-wrapper,
    .swiper-slide {
        height: 100%;
    }
}

.swiper-slide__bg {
    width: 100%;
    height: 100%;
    background-color: var(--v-primary-darken1);
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    transform: scale(1);
}

.visual .swiper-slide.swiper-slide-active .swiper-slide__bg {
    animation: scale 5.5s ease-out forwards;
}

.swiper-slide__bg--1 {
    background-image: url(/images/main/v1.jpg);
}
.swiper-slide__bg--2 {
    background-image: url(/images/main/v2.jpg);
}
.swiper-slide__bg--3 {
    background-image: url(/images/main/v3.jpg);
}
.swiper-slide__bg--4 {
    background-image: url(/images/main/v4.jpg);
}

@keyframes scale {
    0% {
        transform: scale(1.15);
    }
    100% {
        transform: scale(1);
    }
}
@media (min-width: 576px) {
}
@media (min-width: 768px) {
}
@media (min-width: 1024px) {
}
@media (min-width: 1200px) {
}
.visual__ci {
    .visual-ani {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 5;
        overflow: hidden;
    }
}
.visual__ci--top {
    width: 220px;
    height: 18px;
    transform: translateY(100%);
    opacity: 0;
    animation: fadeUp 1.8s 0.5s ease-in-out forwards;
}
.visual__ci--bottom {
    width: 280px;
    height: 18px;
    transform: translateY(100%);
    opacity: 0;
    animation: fadeUp 1.8s 2.3s ease-in-out forwards;
}
.visual__ci--full {
    width: 244px;
    opacity: 0;
    visibility: hidden;
    animation: fade 1.2s 4.1s ease-in-out forwards;
}
@keyframes fadeUp {
    0% {
        transform: translateY(100%);
        opacity: 0;
    }
    33% {
        transform: translateY(0);
        opacity: 1;
    }
    66% {
        transform: translateY(0);
        opacity: 1;
    }
    100% {
        transform: translateY(-100%);
        opacity: 0;
    }
}
@keyframes fade {
    0% {
        opacity: 0;
        visibility: hidden;
    }
    100% {
        opacity: 1;
        visibility: visible;
    }
}
@keyframes bgFadeOut {
    0% {
        background-image: url(/images/main/v1.jpg);
    }
    100% {
        background-image: none;
    }
}
@media (min-width: 576px) {
}
@media (min-width: 768px) {
    .visual__ci--top {
        width: 613px;
        height: 51px;
    }
    .visual__ci--bottom {
        width: 720px;
        height: 51px;
    }
    .visual__ci--full {
        width: 680px;
    }
}
@media (min-width: 1024px) {
    .visual__ci--top {
        width: 780px;
        height: 66px;
    }
    .visual__ci--bottom {
        width: 1000px;
        height: 66px;
    }
    .visual__ci--full {
        width: 867px;
    }
}
@media (min-width: 1200px) {
    .visual__ci--bottom {
        width: 1100px;
    }
}
</style>
